import React from 'react'
import FormFieldError from '../EmailSubscriptionCenter/SignIn/FormFieldError.jsx'

export default function InputGroup({
  handleFormInput,
  fieldName,
  label,
  formData,
  formValidation,
  maxLength,
  textAreaType,
  type,
  rows,
}) {
  return (
    <div className="Grid Grid--withGutter u-marginVert3gu">
      <div className="u-size3of12 u-sm-sizeFull">
        <label
          htmlFor={fieldName}
          className="u-textSecondary u-inlineBlock u-paddingTop1gu u-textNowrap u-sm-marginBottom1gu"
        >
          {label}
          <span className="required u-textColorAlert" aria-required="true">
            {' '}
            *
          </span>
        </label>
      </div>
      <div className="u-size9of12 u-sm-sizeFull">
        {textAreaType ? (
          <textarea
            id={fieldName}
            className="u-paddingHoriz2gu u-paddingVert1gu u-textSizeMsrm1 u-textColorLight u-border u-borderColorSecondary u-sizeFull u-textBreak"
            name={fieldName}
            aria-required="true"
            rows={rows}
            maxLength={maxLength}
            value={formData.messageText || ''}
            onChange={handleFormInput}
          ></textarea>
        ) : (
          <input
            id={fieldName}
            className="u-paddingHoriz2gu u-paddingVert1gu u-textSizeMsrm1 u-textColorLight u-border u-borderColorSecondary u-sizeFull"
            name={fieldName}
            aria-required="true"
            type={type}
            maxLength={maxLength}
            value={formData[fieldName] || ''}
            onChange={handleFormInput}
          />
        )}
        <FormFieldError formValidation={formValidation} fieldName={fieldName} />
      </div>
    </div>
  )
}
